import { useState } from 'react';

import GenericPropertyInput from '../../../FlowDesigner/Components/Inputs/GenericPropertyInput';
import { VariableScope } from '../../../FlowDesigner/Models/VariableScopes/VariableScope';
// Corresponds to PropertyDisplayModel[] in app-runtime/src/UserInterfaceModule/Models/DataDisplayModel.ts
import { DataDisplayPropertyModel } from '../../Models/DataDisplayPropertyModel';
import DataDisplayPropertiesInputContent from './DataDisplayPropertiesInputContent';
import { DataDisplayPropertiesInputDialog } from './DataDisplayPropertiesInputDialog';

type DataDisplayPropertiesInputProps = {
	properties: DataDisplayPropertyModel[] | undefined;
	onPropertiesChange: (properties: DataDisplayPropertyModel[] | undefined) => void;
	variableScope?: VariableScope;
};

export default function DataDisplayPropertiesInput({ properties, onPropertiesChange, variableScope }: DataDisplayPropertiesInputProps) {
	const [open, setOpen] = useState(false);

	return (
		<GenericPropertyInput value={properties} onValueChange={onPropertiesChange} onOpen={() => setOpen(true)}>
			<DataDisplayPropertiesInputContent value={properties} />
			{open && (
				<DataDisplayPropertiesInputDialog
					open={open}
					setOpen={setOpen}
					properties={properties}
					onPropertiesChange={onPropertiesChange}
					variableScope={variableScope}
				/>
			)}
		</GenericPropertyInput>
	);
}
